<script lang="ts">
    import ImageSkeleton from "@components/skeletons/ImageSkeleton.svelte";

    export let imageRatio = 1 / 1;
</script>

<div class="gw-ig-story-card gw-ig-story-card--square">
    <div class="gw-ig-story-card__content gw-ig-story-card__border">
        <ImageSkeleton ratio={imageRatio} class="gw-story-image-skeleton" />
    </div>
</div>

<style>
    .gw-ig-story-card {
        position: relative;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }

    .gw-ig-story-card :global(.gw-story-image-skeleton) {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
    }
</style>
